module.exports = __webpack_public_path__ + "img/rick&morty.8ab113cf.webp";